import { render, staticRenderFns } from "./MeasureCategories.vue?vue&type=template&id=2bb50a6d&"
import script from "./MeasureCategories.vue?vue&type=script&lang=js&"
export * from "./MeasureCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports